import name from './name'

const selectSliceData = state => state[name]
const selectTotal = state => selectSliceData(state).total

export {
  selectTotal
}
